export const links = {
	column1: [
		{
			type: "instagram",
			url: "https://www.instagram.com/p/Cojom3tpSuf/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/CzvxWaDPhfY/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/CyBtBRHpgWg/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "linkedin",
			url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7106872376411271168",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/reel/CrREYwKBH79/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/CrAtTi2JHPs/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/reel/CwAWY4qp3Tg/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
	],
	column2: [
		{
			type: "instagram",
			url: "https://www.instagram.com/p/Com0L8zpivt/?utm_source=ig_embed&amp;utm_campaign=loading",
		},

		{
			type: "instagram",
			url: "https://www.instagram.com/p/CxCw5slPBbO/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/CzUIzPayAKf/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/Clg3xZ2PnLC/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/reel/Cw-oJjzvCsV/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/reel/CrgBAmSIF2p/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/CpcrrfmPMnj/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
	],
	column3: [
		{
			type: "instagram",
			url: "https://www.instagram.com/reel/CpK187JJI6n/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/CzaTvPJSXcY/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/CosGv_YPZDI/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/Cw8b8JVyXyD/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/ClQJj8vJqiu/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/p/CrRJo0fhN4a/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
		{
			type: "instagram",
			url: "https://www.instagram.com/reel/CqDeTgcI7CW/?utm_source=ig_embed&amp;utm_campaign=loading",
		},
	],
};
